/* eslint-disable @typescript-eslint/no-explicit-any */
import { RuleParamSchema, ValidationMessageTemplate } from 'vee-validate/dist/types/types.d';

const name = 'image_height';

const validateImage = (file: File, height: number): Promise<boolean> => {
  const URL = window.URL || (window as any).webkitURL;

  return new Promise((resolve) => {
    const image = new Image();
    image.onerror = () => resolve(false);
    image.onload = () => resolve(image.height === height);

    image.src = URL.createObjectURL(file);
  });
};

const validate = (files: File | File[], { height }: Record<string, any>) => {
  const list = [];
  const validateFiles = Array.isArray(files) ? files : [files];
  for (let i = 0; i < validateFiles.length; i += 1) {
    // if file is not an image, reject.
    if (!/\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(validateFiles[i].name)) {
      return Promise.resolve(false);
    }

    list.push(validateFiles[i]);
  }

  return Promise.all(list.map((file) => validateImage(file, height)))
    .then((values) => values.every((v) => v));
};

const params: RuleParamSchema[] = [
  {
    name: 'height',
    cast(value) {
      return Number(value);
    },
  },
];

const message: ValidationMessageTemplate = (
  field,
  {
    height,
  },
) => `${field} 高度須為 ${height}像素`;

export { validate, params };

export default {
  name,
  validate,
  params,
  message,
};
